import { STTableProp, STTableRow } from "./STTableProps";
import { Box } from '@mui/material';
import CreateTable from "./STcomponents/CreateTable";

export default function STTable(props) {

  return <Box
    sx={{
      width: "100%",
      "& .remove-cell-padding": {
        padding: "0px !important",
      },
    }}
  >
    {CreateTable(props)}
  </Box>
}
export const initRows: STTableRow = {
  nPageIndex: 1,
  nPageSize: 10,

  arrRows: [],
  nDataLength: 0,
  sSortExpression: "sUpdateDate",
  sSortDirection: "desc",
  sID: ""
};
const defaultProp: STTableProp = {
  rows: initRows,
  modeFilter: 3,
  isHiddenToolHead: true,
  isLoading: false,
  onLoadData: () => { },
  DataMode: "server",
  sTableID: "tb1",
  isMenu: true,
  isSortMulti: false,
  filterField: [],
  lstPageSize: [10, 30, 50, 100],
  isPageSize : true,
  isPage : true,
  isShowCheckBox : false,
  isView : false
};
STTable.defaultProps = defaultProp;
